import React, { PureComponent } from 'react';
import styled from 'styled-components';
import InfoTooltip from './InfoTooltip';

const StyledComponentTitle = styled.div`
  font-size: 20px;
  line-height: 26px;
  color: #262f33;
  font-family: latoregular;
  background-color: #f3f2ef;
  padding-bottom: 10px;
  ${props => props.columns && `grid-column: span ${props.columns};`};

  @media print {
    page-break-after: avoid;
  }
`;

class ComponentTitle extends PureComponent {
  render() {
    if (!this.props.title) {
      return null;
    }
    return (
      <StyledComponentTitle columns={this.props.columns}>
        {this.props.title}
        {this.props.info && (
          <InfoTooltip
            text={this.props.info}
            iconColor={`#a3a5a7`}
            iconWidth={`20px`}
            iconHeight={`20px`}
          />
        )}
      </StyledComponentTitle>
    );
  }
}

export default ComponentTitle;
